import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearCurrentPage } from "../ProviderProfileDetails/helper";
import { getViewAdminHistoryAction } from "../../../redux/actions/HelloAdminAction";
import PaginatedItems from "../../../common/Pagination";
import moment from "moment";

export const HistoryAdminDetailPopup = ({
  showHistoryPopup,
  setShowHistoryPopup,
}) => {
  const dispatch = useDispatch();

  const getViewHistory = useSelector(
    (state) => state?.providerPortalDetailReducer?.getViewHistory
  );
  const globalReducer = useSelector((state) => state?.globalReducer);

  useEffect(() => {
    dispatch(
      getViewAdminHistoryAction({
        page: globalReducer?.getCurrentPage,
        rows: 10,
        uId: showHistoryPopup?.userID,
      })
    );
  }, [globalReducer?.getCurrentPage]);

  return (
    <>
      <div className="d-flex justify-content-between border-bottom modalHeader">
        <h4 className="font-bold text-black">History Log</h4>
        <button
          type="button"
          className="btn-close history-close"
          aria-label="Close"
          onClick={() => {
            setShowHistoryPopup(null);
            clearCurrentPage(dispatch);
          }}
        ></button>
      </div>
      <div className="modal-body">
        <div className="table-responsive __custom__properties">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">User Name</th>
                <th scope="col">Provider Name</th>
                <th scope="col">Submitted By</th>
                <th scope="col">Submitted On</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {getViewHistory?.length ? (
                getViewHistory?.map((ele, index) => {
                  return (
                    <tr key={index}>
                      <td>{ele?.userName}</td>
                      <td>{ele?.providerName}</td>
                      <td>{ele?.createdBy}</td>
                      <td>{moment(ele?.createdDate).format("DD-MM-YYYY hh:mm A")}</td>
                      <td>{ele?.action}</td>
                    </tr>
                  );
                })
              ) : (
                <h2
                  style={{
                    marginTop: "20px",
                    color: "red",
                    textAlign: "center",
                  }}
                >
                  No data found
                </h2>
              )}
            </tbody>
          </table>
        </div>
        <div className="mt-2" style={{ paddingBottom: "20px" }}>
          {globalReducer?.getTotalCount !== 0 && (
            <PaginatedItems
              totalCount={globalReducer?.getTotalCount}
              perPageData="10"
            />
          )}
        </div>
      </div>
    </>
  );
};
